import { camelToSnake } from '~/utils/object';
import { get, put, URLs } from './request';

export const getNotifications = async () => {
  const { data } = await get({
    url: `${URLs.api}/user_preference`,
  });
  return {
    lunchArrivalSmsDisabled: data['lunch_arrival_sms_disabled?'],
    lunchArrivalEmailDisabled: data['lunch_arrival_email_disabled?'],
    lunchArrivalPushNotificationDisabled: data['lunch_arrival_push_notification_disabled?'],
    marketingEmailDisabled: data['marketing_email_disabled?'],
    shuttleReminderEmailDisabled: data['shuttle_reminder_email_disabled?'],
  };
};

const boolToString = (bool) => (bool ? '1' : '0');

/**
 * Send notifcation preferences to the server
 * @param {PreferenceState.Preference} preferences
 * @param {number} mixpanelDistinctId
 */
export const putNotifications = async (preferences, mixpanelDistinctId) => {
  const {
    lunchArrivalEmailDisabled,
    lunchArrivalSmsDisabled,
    lunchArrivalPushNotificationDisabled,
    marketingEmailDisabled,
    shuttleReminderEmailDisabled,
  } = preferences;

  return await put({
    url: `${URLs.api}/user_preference`,
    data: camelToSnake({
      lunchArrivalEmailDisabled: boolToString(lunchArrivalEmailDisabled),
      lunchArrivalSmsDisabled: boolToString(lunchArrivalSmsDisabled),
      lunchArrivalPushNotificationDisabled: boolToString(lunchArrivalPushNotificationDisabled),
      marketingEmailDisabled: boolToString(marketingEmailDisabled),
      shuttleReminderEmailDisabled: boolToString(shuttleReminderEmailDisabled),
      mixpanelDistinctId,
    }),
  });
};
